import {Injectable, NgZone} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Select, Store} from '@ngxs/store';
import {AuthenticationService} from '../../service/auth.service';
import {SwalUtil} from '../../util/swal-util';
import {GetAccountStatusAction} from '../../actions/account.actions';
import {combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { UserProfileApiService } from 'src/app/api/user-profile-api.service';

@Injectable({
  providedIn: 'root'
})
export class DisabledGuard  {


  constructor(
    protected router: Router, protected store: Store,
    protected authenticationService: AuthenticationService,
    protected ngZone: NgZone, protected swalUtil: SwalUtil,
    protected userProfileApiService: UserProfileApiService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const status$ = this.store.dispatch(new GetAccountStatusAction);
    const partner$ = this.userProfileApiService.getPartnerAssociated();
    return combineLatest([
          status$,
          partner$
      ]).pipe(
        map(([data, partner]) => {
          if ( data.account.accountStatus.disabled){
            this.showMessage(partner);
            return false;
          } else {
            return true;
          }
        })
      )
  }

  protected showMessage(partner: any): void {
    SwalUtil.fireGenericMessage('Atención', 'Su Usuario fue Suspendido. Para más información, comuníquese con MercadoCheque enviando un email a validaciones@mercadocheque.com o enviando un mensaje a nuestro Whatsapp: +' + (partner ? partner?.telefonos[0].phoneNumber : '1164853540')).then(value => {
        this.router.navigate(['/home']);
      }
    );
  }

}
